export const global = {
  'html, body': {
    color: '#191919'
  },
  a: {
    textDecoration: 'underline'
  }
}
